const isNil = (value) => value === undefined || value === null;

export default isNil;
